import React from 'react'
import cx from 'classnames'

import { CurrentPlanCard } from './CurrentPlanCard'
import { TargetPlanCard } from './TargetPlanCard'
import { MigrationPlansViewReady } from './useMigrationPlansView'

import cm from './MigrationPlansView.module.css'

interface PriceDownPlansViewProps {
  migrationViewData: MigrationPlansViewReady
}

export const PriceDownPlansView = ({ migrationViewData }: PriceDownPlansViewProps) => {
  return (
    <div className={cx(cm.contentBox, cm.twoColumnBox, cm.twoColumnBoxReversed)}>
      <CurrentPlanCard />
      <TargetPlanCard migrationViewData={migrationViewData} />
    </div>
  )
}
